import { styled } from '@zenbusiness/zui/styles';
import TextField from '@zenbusiness/zui/TextField';

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputLabel-root': {
    transition: 'all 0.3s ease'
  },
  '& .MuiInputLabel-shrink': {
    // Adjust the top when label shrinks
    top: '-6px',
    marginLeft: '0',
    ...theme.typography.xs
  },
  '& .MuiInputLabel-root.Mui-focused': {
    top: '0',
    marginLeft: '0',
    ...theme.typography.xs
  }
}));
